import { areaChartConfiguration } from './AreaChart/configurations/AreaChart.configuration.js';
import { barChartConfiguration } from './BarChart/configurations/BarChart.configuration.js';
import { barScaleConfiguration } from './BarScale/configurations/BarScale.configuration.js';
import { blockRangeChartConfiguration } from './BlockRangeChart/configurations/BlockRangeChart.configuration.js';
import { chartBaseConfiguration } from './ChartBase/configurations/ChartBase.configuration.js';
import { chartPeriodSelectionConfiguration } from './ChartPeriodSelection/configurations/ChartPeriodSelection.configuration.js';
import { chartTableComboConfiguration } from './ChartTableCombo/configurations/ChartTableCombo.configuration.js';
import { gaugeChartConfiguration } from './GaugeChart/configurations/GaugeChart.configuration.js';
import { lineChartConfiguration } from './LineChart/configurations/LineChart.configuration.js';
import { radialChartConfiguration } from './RadialChart/configurations/RadialChart.configuration.js';
import { rangeChartConfiguration } from './RangeChart/configurations/RangeChart.configuration.js';
import { relativePerformanceChartConfiguration } from './RelativePerformanceChart/configurations/RelativePerformanceChart.configuration.js';
import { scatterChartConfiguration } from './ScatterChart/configurations/ScatterChart.configuration.js';
import { steppedBlockChartConfiguration } from './SteppedBlockChart/configurations/SteppedBlockChart.configuration.js';
import { IChartingConfiguration } from './IChartingConfiguration.js';
/* [Component: import] */
/* [ChartComponent: import] */

export const chartingConfiguration: IChartingConfiguration = {
	chartBase: chartBaseConfiguration,
	barChart: barChartConfiguration,
	lineChart: lineChartConfiguration,
	areaChart: areaChartConfiguration,
	scatterChart: scatterChartConfiguration,
	chartTableCombo: chartTableComboConfiguration,
	chartPeriodSelection: chartPeriodSelectionConfiguration,
	rangeChart: rangeChartConfiguration,
	blockRangeChart: blockRangeChartConfiguration,
	relativePerformanceChart: relativePerformanceChartConfiguration,
	steppedBlockChart: steppedBlockChartConfiguration,
	gaugeChart: gaugeChartConfiguration,
	radialChart: radialChartConfiguration,
	barScale: barScaleConfiguration,
	/* [Component: interface] */
	/* [ChartComponent: interface] */
};
